<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import axios from 'axios'
import get from './api/get'
export default {
  name: 'App',
  created(){
    // console.log(axios)
    // console.log(get)
    //获取公共部分信息
    // get('/api/configPublic',{}).then((res)=>{
    //   if(res.data.code==200){
    //     var data = JSON.stringify(res.data.data)
    //     sessionStorage.setItem('public',data)
    //   }else{
    //     alert('网络连接失败，请稍后重试')
    //   }
    // })
    //获取轮播图片
    // get('/api/bannerList',{type:1}).then((res)=>{
    //   if(res.data.code==200){
    //     var banners =JSON.stringify(res.data.data.banners)
    //     sessionStorage.setItem('banners',banners)
    //   }
    // })
    // //获取相关服务
    // get('/api/categoryTextList',{category_id:3,
    // lg:localStorage.localeLanguage}).then((res)=>{
    //   if(res.data.code==200){
    //     // console.log(res)
    //     var server = JSON.stringify(res.data.data.cTexts)
    //     sessionStorage.setItem('server',server)
    //   }
    // })
    //获取解决方案
    // get('/api/categoryTextList',{category_id:2,
    // lg:localStorage.localeLanguage}).then((res)=>{
    //   if(res.data.code==200){
    //     // console.log(res)
    //     var software = JSON.stringify(res.data.data.cTexts)
    //     sessionStorage.setItem('software',software)
    //   }
    // })
    //获取公司介绍
    // get('/api/categoryTextList',{category_id:4}).then((res)=>{
        
    //     if(res.data.code==200){
    //     var company = JSON.stringify(res.data.data.cTexts)
    //     sessionStorage.setItem('company',company)
    //     }
    // })
    //获取工作机会列表
    // get('/api/jobList',{
    //   lg:localStorage.localeLanguage
    // }).then((res)=>{
    //   if(res.data.code==200){
    //     var jobs = JSON.stringify(res.data.data.jobs)
    //     sessionStorage.setItem('jobs',jobs)
    //   }
    // })
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue